import { render, staticRenderFns } from "./DropBox.vue?vue&type=template&id=1d8738df&lang=pug&"
import script from "./DropBox.vue?vue&type=script&lang=js&"
export * from "./DropBox.vue?vue&type=script&lang=js&"
import style0 from "./DropBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports